<template>
    <div class="weather-view">
        <h2 class="title">{{$t('weather.title')}}</h2>
        <div class="controls" v-if="loaded">
            <div class="date-controls">
                <button @click="decreaseIncrement">
                    <font-awesome-icon icon="chevron-left"></font-awesome-icon>
                </button>
                <div class="date"><span class="today"
                                        v-if="dayIncrement===0">{{$t('general.today')}} - </span> {{day}}
                </div>
                <button @click="increaseIncrement" v-if="dayIncrement<0">
                    <font-awesome-icon icon="chevron-right"></font-awesome-icon>
                </button>
            </div>
            <input :placeholder="$t('general.search')" type="text" v-if="loaded" v-model="search"/>
        </div>
        <div class="wrapper" v-if="loaded">
            <div :key="salon.id" class="card-container" v-for="salon in filteredSalons">
                <WeatherCard :salon="salon" :weather="salon.weather"></WeatherCard>
            </div>
        </div>
        <Preloader v-if="!loaded"></Preloader>
    </div>
</template>

<script>
import WeatherCard from '@/components/weather/WeatherCard';
import { RepositoryFactory } from '@/api/RepositoryFactory';
import Preloader from '@/components/helpers/Preloader.vue';

const SalonsRepository = RepositoryFactory.get('salons');
const WeatherRepository = RepositoryFactory.get('weather');

export default {
  name: 'Weather',
  components: {
    WeatherCard,
    Preloader,
  },
  data() {
    return {
      loaded: false,
      search: '',
      salons: [
        {
          name: 'Loading',
          city: 'Loading',
        },
      ],
      dayIncrement: 0,
    };
  },
  watch: {
    async groupID(newValue) {
      this.loaded = false;
      await this.fetchWeather(newValue, this.dayIncrement);
      this.loaded = true;
    },
    async dayIncrement(newValue) {
      this.loaded = false;
      await this.fetchWeather(this.groupID, newValue);
      this.loaded = true;
    },
  },
  async mounted() {
    this.loaded = false;
    await this.fetchWeather(this.$store.getters.selectedGroup.id, 0);
    this.loaded = true;
  },
  computed: {
    groupID() {
      return this.$store.getters.selectedGroup.id;
    },
    filteredSalons() {
      const { salons } = this;
      salons.forEach(((value, key) => {
        if (!(value.city) || !(value.name)) {
          salons.splice(key, 1);
        }
      }));
      if (salons.length > 1) {
        return salons.filter(salon => ((salon.city !== null && salon.name !== null) && (salon.city.toLowerCase().includes((this.search.toLowerCase()))
            || salon.name.toLowerCase().includes((this.search.toLowerCase())))));
      }

      return this.salons;
    },
    day() {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + this.dayIncrement);
      return `${tomorrow.getDate()}.${tomorrow.getMonth() + 1}.${tomorrow.getFullYear()}`;
    }
    ,
  },
  methods: {
    async fetchWeather(groupID, dayIncrement) {
      const { token } = this.$store.getters;
      this.salons = await WeatherRepository.getWeather(groupID, dayIncrement, token);
    },
    decreaseIncrement() {
      this.dayIncrement -= 1;
    },
    increaseIncrement() {
      this.dayIncrement += 1;
    }
    ,
  }
  ,
};
</script>

<style lang="scss" scoped>
    .weather-view {
        /*width: 1510px;*/
        margin: 0 auto;

        .card-container {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            width: 660px;
            margin: 10px 0;
            @include media('<665px') {
                width: 100%;
            }
        }

        .wrapper {
            width: 100%;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
        }
    }

    input {
        border: 1px solid #e5e5e5;
        width: 611px;
        box-sizing: border-box;
        padding: 20px 40px;
        border-radius: 5px;
        /*margin-left: auto;*/
        margin-top: 11px;

    }

    .controls {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;

        .date-controls {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-weight: 800;
            // color: $baseTextColor;

            .date {
                margin: 0 25px;
            }

            .today {
                color: $peacock-blue;
                font-weight: 800;
                text-transform: capitalize;
            }

            button {
                background: none;
                border: none;
                color: $peacock-blue
            }
        }
    }

</style>
